// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__qG9XU","comment":"styles_comment__2iR5Q"};